import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(query, $completion) {
  return (yield* this.get_performer_ggzbqd_k$().apolloQuery_2xqb1_k$(query.query_1, $completion)).get_dataAssertNoErrors_kaff3v_k$();
}
var SdkGraphQueryDispatcherClass;
function SdkGraphQueryDispatcher() {
  if (SdkGraphQueryDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkGraphQueryDispatcher', VOID, VOID, [GqlTrait()], [1]);
    SdkGraphQueryDispatcherClass = $;
  }
  return SdkGraphQueryDispatcherClass;
}
//region block: exports
export {
  SdkGraphQueryDispatcher as SdkGraphQueryDispatcher2qog4v6gbj5of,
  perform as performtlgovo9nugf,
};
//endregion

//# sourceMappingURL=SdkGraphQueryDispatcher.mjs.map
